
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MessageItemProps } from ".";
import { loading, endLoading } from "store/message";

interface ApiMessageRemoveInputProps {
    ids: number[]
}

type ApiMessageRemoveOutputProps = OutputBaseProps<{ item: MessageItemProps; }>

export const apiMessageRemove = async (data: ApiMessageRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiMessageRemoveOutputProps>("/api/message/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};